import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody
} from "@nextui-org/react";
import FormCrudDrivers from "./FormCrudDrivers";

export default function ModalDriversData({
  isOpen,
  onClose,
  titileModel,
  fieldFlagReadOnly,
  driverSelected,
  driverAction
}) {
  return (
    <Modal
      backdrop={"blur"}
      isOpen={isOpen}
      onClose={onClose}
      placement={"center"}
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1">
              {titileModel}
            </ModalHeader>
            <ModalBody>
              <div>
                <FormCrudDrivers
                  driver={driverSelected}
                  readOnly={fieldFlagReadOnly}
                  driverAction={driverAction}
                  onClose={onClose}
                />
              </div>
            </ModalBody>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}
